function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#891818;}.b{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M60,46.3A13.694,13.694,0,0,1,46.3,60H13.7A13.694,13.694,0,0,1,0,46.3V13.711A13.714,13.714,0,0,1,13.711,0H46.09A13.9,13.9,0,0,1,60,13.91Z"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.216 8.228)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M100.645,70.6H83.923A13.427,13.427,0,0,0,70.5,84.023v16.711a13.409,13.409,0,0,0,13.423,13.411h16.711a13.407,13.407,0,0,0,13.411-13.411V84.023A13.392,13.392,0,0,0,100.645,70.6Zm9.23,28.525a10.836,10.836,0,0,1-10.839,10.839H85.532A10.836,10.836,0,0,1,74.692,99.125V85.62A10.836,10.836,0,0,1,85.532,74.781H99.037A10.843,10.843,0,0,1,109.876,85.62Z",
  transform: "translate(-70.5 -70.6)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M174.686,159a11.553,11.553,0,1,0,11.386,11.552A11.464,11.464,0,0,0,174.686,159Zm0,18.493a6.953,6.953,0,1,1,6.852-6.952A6.9,6.9,0,0,1,174.686,177.493Z",
  transform: "translate(-152.309 -148.698)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M332.88,135.5a2.89,2.89,0,1,1-2.89-2.9A2.89,2.89,0,0,1,332.88,135.5Z",
  transform: "translate(-296.931 -125.31)"
}));

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0a9cce7f.svg";
export { ForwardRef as ReactComponent };